import React from "react";
import styled from "styled-components";

const PayoutTabContainer = styled.div`  
`

const PayoutTabHolder = styled.div`
    display: flex;
    position: relative;
    box-shadow: 0 0 1px 0 rgba(#185ee0, 0.15), 0 6px 12px 0 rgba(#185ee0, 0.15);
    border-radius: 20px;
    margin: 8px;
    height: 100%;
    background-color: var(--Dove);
    padding: 16px;
    justify-content: space-between;
    cursor: pointer;
	transition: color 0.15s ease-in;
    * {
        z-index: 2;
    }
    @media(max-width: 600px){
        width: unset;
        border-radius: 99px;
    }
`

const Glider = styled.span`
    position: absolute;
    display: flex;
    height: 40px;
    width: ${({ width }) => width || 100}px;
    background-color: rgba(	6, 138, 226, 0.08);
    z-index: 1;
    border-radius: 16px;
    transition: 0.40s ease-out;
    @media(max-width:600px){
        border-radius: 20px;
    }
`


const TabLabel = styled.label`
    font-size: 16px;
    font-weight: 600;
    color: rgba(13, 21, 54, 0.65);
    text-align: center;
    padding: 8px;
    @media(max-width: 600px){
        font-size: 14px;
    }
`

const StyledRadioInput = styled.input.attrs({ type: 'radio' })`
    display: none;  
    &:checked {
        & + ${TabLabel} {
            color: #068AE2;
        }
    }
`


const Radio1Input = styled(StyledRadioInput).attrs({ id: 'radio-1'})`
    &:checked {
        & ~ ${Glider}  {
            transform: translateX(0);
        }
    }
`

const Radio2Input = styled(StyledRadioInput).attrs({ id: 'radio-2'})`
    &:checked {
        & ~ ${Glider}  {
            transform: translateX(${({ transformX }) => transformX}px);
        }
    }
`

const Radio3Input = styled(StyledRadioInput).attrs({ id: 'radio-3'})`
    &:checked {
        & ~ ${Glider} {
            transform: translateX(${({ transformX }) => transformX}px);
        }
    }
`


const payoutTabsObject = [
    {name: 'upcoming_payout', label: 'Upcoming Payout',RadioComp: Radio1Input },
    {name: 'last_payout', label: 'Last Payout',RadioComp: Radio2Input},
    {name: 'overall', label: 'Overall', RadioComp: Radio3Input}
]


const TermPeriodTabs = ({ periodTab, updateTabs }) => {
    const setGliderOffset = () => {
        const activeTab = document.querySelector('input[name="tabs"]:checked + .tab');
        return ((activeTab?.offsetLeft || 200) - 16)
    }
    const getWidthOfGlider = () => {
        const index = periodTab === 'last_payout' ? 2 : periodTab === 'overall' ? 3 : 1
        const width = document.getElementById(`label-${index}`)?.clientWidth
        return width
    }
    return(
        <PayoutTabContainer>
            <PayoutTabHolder>
                {payoutTabsObject.map((tab, index) => {
                    const { label, name, RadioComp } = tab
                    return(
                        <>
                            <RadioComp type="radio" id={`radio-${index+1}`} name="tabs" checked={periodTab === name} onClick={() => updateTabs(name)} transformX={setGliderOffset}/>
                            <TabLabel className="tab" id={`label-${index+1}`} htmlFor={`radio-${index+1}`} >{label}</TabLabel>
                        </>
                    )
                })}
                <Glider id="glider" width={getWidthOfGlider}/>
            </PayoutTabHolder>
        </PayoutTabContainer>
    )
}

export default TermPeriodTabs